import { fromJS } from 'immutable';

import { setStateCurrentType } from '@Constants/StateCurrent';

export const initialState = fromJS({
  name: null,
});

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  if (action.type === setStateCurrentType) {
    const { stateCurrent } = action;
    return state.merge(fromJS(stateCurrent));
  }

  return state;
}
